import { combineReducers } from 'redux';

import agreement from './agreement/agreementReducer';
import payment from './payment/paymentReducer';

export default combineReducers({
	agreement,
	payment,
});
